// @ts-nocheck
// This file is auto-generated by screw-up plugin
// Do not edit manually

export const name = "funcity-it";
export const version = "1.5.0";
export const description = "funcity in-browser runner";
export const author = "Kouji Matsui (@kekyo@mi.kekyo.net)";
export const license = "MIT";
export const repository_url = "https://github.com/kekyo/funcity";
export const git_commit_hash = "e583c1a43f3a2b29f8bbbb7b7ad0cc199b0a0fca";
